module.exports = {
  "country": "PT",
  "artist": "The Black Mamba",
  "song": "Love is on my Side",
  "year": "2021",
  "place": "12",
  "spotify": "4S4RWAA749dKyJQ5CiKEBJ"
};